export const repairOrderKeys = {
  repairOrders: () => ['REPAIR_ORDERS'] as const,
  repairOrder: (repairOrderId: number | string) =>
    [...repairOrderKeys.repairOrders(), repairOrderId] as const,
  repairOrderStatistics: () => ['REPAIR_ORDER_STATISTICS'] as const,
};
